import jQuery from 'jquery';
import * as Popper from "@popperjs/core"
import Modal from 'bootstrap';

var Flickity = require('flickity');
require('flickity-imagesloaded');

import {settings} from './variables.js';
import lightGallery from '../lib/lightgallery/js/lightgallery.js';

var baseUrl = settings.apiBaseUrl;

require('./actions.js')

getDropdowns()
getCollapses()


const countDownFrontpage = document.getElementById('countdown_timer')
if (countDownFrontpage) {
  countdownTimer(countDownFrontpage)
}

if (jQuery(".lightgallery").length) {
  jQuery(".lightgallery").lightGallery({
    selector: '.gallery-item-n',
    pager: false,
    download: false
  });
}


/**
 * Подмена заголовков и описания модальной формы
 */
 
 
const exampleModal = document.getElementById('mainModal')
exampleModal.addEventListener('show.bs.modal', event => {
  
  const button = event.relatedTarget
  
  const mTtile = button.getAttribute('data-bs-mtitle')
  
  if (mTtile) {
    const modalTitle = exampleModal.querySelector('.modal-title')
    modalTitle.textContent = mTtile
  }

  const mText = button.getAttribute('data-bs-mtext')
  
  if (mText) {
    const modalAnons = exampleModal.querySelector('.modal-anons')
    modalAnons.textContent = mText
  }
  
})

const documentsModal = document.getElementById('documentsModal')

if (documentsModal) {
  documentsModal.addEventListener('show.bs.modal', event => {
    
    const button = event.relatedTarget
    
    const mTtile = button.getAttribute('data-bs-mtitle')
    
    if (mTtile) {
      const modalTitle = documentsModal.querySelector('.modal-title')
      modalTitle.textContent = mTtile
    }

    const mText = button.getAttribute('data-bs-mtext')
    
    if (mText) {
      const modalAnons = documentsModal.querySelector('.modal-anons')
      modalAnons.innerHTML = mText
    }

    const mImage = button.getAttribute('data-bs-mimage')
    
    if (mImage) {
      const modalImage = documentsModal.querySelector('.document-img')
      modalImage.src = mImage
    }
    
  })
}
